import { PhotoCamera } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendDeviceCommand } from '~/api/devices';
import { Screenshot as DeviceScreenshot } from '~/components/devices';
import { SettingsBody, SettingsData, SettingsHead } from '~/components/settings';
import { DeviceCommandKind } from '~/generated/graphql';
import type { Device } from '../types';

interface ScreenshotProps {
  device: Device;
}

export const Screenshot = ({ device }: ScreenshotProps) => {
  const { t } = useTranslation();
  const [sendCommand, { loading }] = useSendDeviceCommand();

  const handleClick = useCallback(async () => {
    await sendCommand({
      variables: {
        input: {
          command: DeviceCommandKind.Screenshot,
          selected: { ids: [device.id] },
          payload: {},
        },
      },
    });
  }, [device, sendCommand]);

  return (
    <>
      <SettingsHead>{t('pages.devices.show.preview.screenshot')}</SettingsHead>
      <SettingsBody>
        <SettingsData className="last" sx={{ flexDirection: 'column', gap: 1 }}>
          <DeviceScreenshot
            openInNewTab
            pollInterval={device.demo ? 0 : 60_000}
            screenshotUri={device.screenshotUri}
          />
          {/* TODO: don't show for content editor, needs fix */}
          {device.canUpdate.value && (
            <Button
              disabled={loading}
              onClick={async () => await handleClick()}
              startIcon={<PhotoCamera />}
              variant="contained"
            >
              {t('pages.devices.show.preview.take_screenshot')}
            </Button>
          )}
        </SettingsData>
      </SettingsBody>
    </>
  );
};
